export default __webpack_public_path__ + "static/media/O.eb4fd06f.png";